<div class="container">
    <h2 class="rounded mt-3 text-center">Education Log</h2>
    <div class="card m-2 p-2" [formGroup]="form">
<!--        <prettyjson [obj]="form.value"></prettyjson>-->
        <mat-form-field>
            <mat-label>Centre Name</mat-label>
            <mat-select [(ngModel)]="centreControl"  (selectionChange)="onCentreSelect($event)">
                <mat-option *ngFor="let c of mCentres$|async" [value]="c">{{c.centreName}}
                </mat-option>
            </mat-select>
        </mat-form-field>


        <mat-form-field>
            <mat-label>Floor</mat-label>
            <mat-select formControlName="floor">
                <mat-option *ngFor="let f of floors" [value]="f">{{f}}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field >
            <mat-label>Session Type</mat-label>
            <mat-select formControlName="sessionType">
                <mat-option *ngFor="let t of sessionTypes" [value]="t">{{t}}</mat-option>
            </mat-select>
        </mat-form-field>

<!--        <mat-form-field>-->
<!--            <mat-select formControlName="topicsCovered">-->
<!--                <mat-option *ngFor="let t of topicsCovered$|async" [value]="t">{{t}}</mat-option>-->
<!--            </mat-select><mat-label>Topic Name</mat-label>-->

<!--        </mat-form-field>-->
        <mat-form-field >
            <mat-label>Choose a date</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="sessionDate">
            <mat-hint>DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle  matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="onSubmit()">Submit</button>



    </div>



</div>
